/**
 * OutstandingActions — CCD-DASH-014 Phase A · R3a.
 *
 * "What should I do next?" — a decision list of the highest-priority
 * unearned contributions from Voyage Readiness. Every row deep-links
 * into the responsible workspace so the traveler goes from question
 * to action in one click.
 *
 * Consumes the `outstanding_actions[]` slice of GET /voyage-readiness.
 * Design: /app/docs/design/CCD-DASH-014-dashboard-design-sprint.md §1.1 · R3a
 */
import React from "react";
import { useCruise } from "@/context/CruiseContext";
import { ListChecks, ArrowRight } from "lucide-react";
import HomeSummaryCard from "./HomeSummaryCard";

export function OutstandingActions({ actions }) {
  const { setRoute } = useCruise();
  const rows = Array.isArray(actions) ? actions : [];

  return (
    <HomeSummaryCard
      eyebrow="Outstanding Actions"
      icon={<ListChecks className="w-3 h-3" />}
      title="What to do next"
      testId="outstanding-actions-card"
    >
      {rows.length === 0 ? (
        <div className="font-body text-[13px] text-slate-500 leading-relaxed">
          Nothing outstanding. Your voyage is on rails — enjoy the planning.
        </div>
      ) : (
        <ul className="divide-y divide-slate-100" data-testid="outstanding-actions-list">
          {rows.map((a) => (
            <li key={a.id}>
              <button
                type="button"
                onClick={() => a.route && setRoute(a.route)}
                className="w-full flex items-center gap-3 py-2.5 text-left group hover:bg-slate-50 transition-colors -mx-1 px-1 rounded"
                data-testid={`outstanding-action-${a.id}`}
              >
                <span className="mt-0.5 w-1.5 h-1.5 rounded-full bg-slate-400 shrink-0" aria-hidden="true" />
                <span className="flex-1 min-w-0">
                  <span className="block font-body text-[13px] text-slate-800 truncate">
                    {a.label}
                  </span>
                  <span className="block font-body text-[11px] text-slate-400 uppercase tracking-[0.10em]">
                    {a.domain}
                  </span>
                </span>
                <ArrowRight className="w-3.5 h-3.5 text-slate-400 group-hover:text-slate-700 transition-colors" aria-hidden="true" />
              </button>
            </li>
          ))}
        </ul>
      )}
    </HomeSummaryCard>
  );
}

export default OutstandingActions;
